
import { NotificationConfig, DEFAULT_CONFIG } from '@/types/notificationConfig';
import { NotificationUtils } from './NotificationUtils';

export class ConfigManager {
  private static readonly CONFIG_STORAGE_KEY = 'notification_config';
  private config: Record<string, NotificationConfig> = {};

  constructor() {
    this.loadConfig();
  }

  private loadConfig(): void {
    const savedConfig = NotificationUtils.loadFromStorage(ConfigManager.CONFIG_STORAGE_KEY);
    this.config = savedConfig || {};
  }

  public getConfig(category?: string): NotificationConfig {
    if (category && this.config[category]) {
      return this.config[category];
    }
    return { ...DEFAULT_CONFIG };
  }

  public setConfig(config: NotificationConfig, category: string): boolean {
    try {
      this.config[category] = config;
      NotificationUtils.saveToStorage(ConfigManager.CONFIG_STORAGE_KEY, this.config);
      return true;
    } catch (error) {
      console.error('Error saving notification config:', error);
      return false;
    }
  }
}
